__turbopack_context__.v({
  "body": "H-kwZG_body",
  "card": "H-kwZG_card",
  "card--placeholder": "H-kwZG_card--placeholder",
  "date": "H-kwZG_date",
  "date__live": "H-kwZG_date__live",
  "date__today": "H-kwZG_date__today",
  "footer": "H-kwZG_footer",
  "header": "H-kwZG_header",
  "shimmer": "H-kwZG_shimmer",
  "teams": "H-kwZG_teams",
  "teams--placeholder": "H-kwZG_teams--placeholder",
  "teams__away--logo": "H-kwZG_teams__away--logo",
  "teams__away--name": "H-kwZG_teams__away--name",
  "teams__home--logo": "H-kwZG_teams__home--logo",
  "teams__home--name": "H-kwZG_teams__home--name",
  "text-bar-sweep": "H-kwZG_text-bar-sweep",
  "tournament": "H-kwZG_tournament",
  "tournament__name": "H-kwZG_tournament__name",
});
